import uiCalendar from './calendar/index.vue'
import uiCalendarRange from './calendar-range/index.vue'
import uiCheckbox from './checkbox/index.vue'
import uiColorPicker from './color-picker/index.vue'
import uiDateRange from './date-range/index.vue'
import uiDate from './date/index.vue'
import uiDatepickerRange from './datepicker-range/index.vue'
import uiDatepicker from './datepicker/index.vue'
import uiInputMoney from './input-money/index.vue'
import uiInputNumber from './input-number/index.vue'
import uiInputValueToPercent from './input-value-to-percent/index.vue'
import uiInput from './input/index.vue'
// organize-imports-disable-next-line
import uiInputCep from './cep/index.vue'; // Desabilitado ordenação pois o uiInputCep utiliza o uiInput
import uiRadio from './radio/index.vue'
import uiSelectColor from './select-color/index.vue'
import uiSelectTags from './select-tags/index.vue'
import uiSelectV2 from './select-v2/index.vue'
import uiSelectV3 from './select-v3/index.vue'
import uiSelect from './select/index.vue'
import uiSwitch from './switch/index.vue'
import uiTextEditor from './text-editor'
import uiTextarea from './textarea/index.vue'
import uiSelect2 from './uiSelect2/index.vue'
import uiTextWithSelectArea from './util/text-with-select-area/index.vue'
import  uiInputNumberStepper  from './input-number-stepper/index.vue'
import uiTextareaV2 from './textarea-v2/index.vue'

export {
	uiCalendar,
	uiCheckbox,
	uiColorPicker,
	uiDate,
	uiDateRange,
	uiDatepicker,
	uiDatepickerRange,
	uiInput,
	uiInputCep,
	uiInputMoney,
	uiInputNumber,
	uiInputValueToPercent,
	uiRadio,
	uiSelect,
	uiSelect2,
	uiSelectColor,
	uiSelectTags,
	uiSelectV2,
	uiSelectV3,
	uiSwitch,
	uiTextEditor,
	uiTextWithSelectArea,
	uiTextarea,
	uiTextareaV2,
	uiCalendarRange,
	uiInputNumberStepper
}
